// extracted by mini-css-extract-plugin
module.exports = {"spin":"styles_spin__2ulKO","rotation":"styles_rotation__GD75E","container":"styles_container__hrv0U"};